import { Injectable } from '@angular/core';

import { en } from '@rpgc-ai/i18n/en';

import type { Translation, TranslocoLoader } from '@jsverse/transloco';
import { from, type Observable, of } from 'rxjs';

import { getSafeLanguageCode, type SupportedLanguageCode } from './languages';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: SupportedLanguageCode): Observable<Translation> {
    const safeLang = getSafeLanguageCode(lang);

    if (safeLang === 'en') {
      return of(en);
    }

    return from(this.#loadTranslation(safeLang));
  }

  async #loadTranslation(lang: Exclude<SupportedLanguageCode, 'en'>): Promise<Translation> {
    switch (lang) {
      case 'ru': return (await import('@rpgc-ai/i18n/ru')).ru;
      case 'ua': return (await import('@rpgc-ai/i18n/ua')).ua;
      case 'de': return (await import('@rpgc-ai/i18n/de')).de;
    }
  }
}
